export default {
  methods: {
    saveLoginInfo: function (userInfo) {
      localStorage.userInfo = JSON.stringify(userInfo)
    },
    getLoginInfo: function () {
      if (localStorage.userInfo) {
        let userInfo = JSON.parse(localStorage.userInfo)
        return userInfo
      } else {
        return null
      }
    },
    getLoginAccountId: function () {
      let userInfo = this.getLoginInfo()
      if (!userInfo) {
        return null
      }
      return userInfo.id || userInfo.employeeId || null
    }
  }

}
